var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      value: _vm.value,
      items: _vm.clients,
      loading: _vm.loading,
      label: "Clientes",
      "item-text": "nombre",
      "item-value": "rut",
      "return-object": ""
    },
    on: {
      change: function($event) {
        return _vm.$emit("input", _vm.filter)
      }
    },
    model: {
      value: _vm.filter,
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }